import React from "react";
import { PageImage, SCRIPT_KEYS, boxStyle } from "@/components/docs/PageImage";

const today = () => new Date().toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric", timeZone: "America/New_York" });

/** The document as it will look: pages with their details already filled in, and inputs for the blanks only they fill. */
export function FilledPages({ api, base, qid, form, fills, setFills, typedName, prefix }) {
  const shown = (f) => (f.key === "signature" ? typedName : f.key === "date_signed" ? (typedName.trim() ? today() : "") : f.value);
  return (
    <div className="space-y-4" data-testid={`${prefix}-pages`}>
      {form.pages.map((pg, n) => (
        <PageImage key={n} api={api} path={`${base}/${qid}/page/${n}`} n={n} testid={`${prefix}-page-${n}`}>
          {form.fields.filter((f) => f.page === n).map((f) => (
            <div key={f.id} style={boxStyle(f)} className="absolute">
              {f.editable ? (
                <input value={fills[f.id] || ""} onChange={(e) => setFills({ ...fills, [f.id]: e.target.value })} placeholder={`${f.label}${f.required ? " *" : ""}`} title={f.label}
                  data-testid={`${prefix}-fill-${f.id}`} className="w-full h-full min-h-[18px] px-1 text-[11px] sm:text-xs bg-amber-100/90 border border-amber-500 text-slate-900 rounded-sm outline-none focus:ring-2 focus:ring-amber-400" />
              ) : (
                <div data-testid={`${prefix}-value-${f.key}-${f.id}`} className={`w-full h-full flex items-end px-0.5 overflow-hidden whitespace-nowrap text-[#0b1f4d] ${shown(f) ? "" : "bg-sky-100/60 border border-dashed border-sky-400"}`}
                  style={SCRIPT_KEYS.has(f.key) ? { fontFamily: "'Great Vibes', cursive", fontSize: "clamp(12px, 2.4vw, 24px)", lineHeight: 1 } : { fontSize: "clamp(8px, 1.3vw, 12px)" }}>
                  {shown(f) || <span className="text-[9px] text-sky-700">{f.key === "signature" ? "Your signature" : f.label}</span>}
                </div>
              )}
            </div>
          ))}
        </PageImage>
      ))}
      {form.fields.some((f) => f.editable) && (
        <div className="sticky bottom-0 rounded-md bg-slate-900/95 border border-amber-400/40 p-3 space-y-2" data-testid={`${prefix}-blanks-list`}>
          <div className="text-xs text-amber-200">Fill in these blanks (they appear in the yellow boxes above)</div>
          {form.fields.filter((f) => f.editable).map((f) => (
            <label key={f.id} className="block space-y-0.5"><span className="text-[11px] text-white/70">{f.label}{f.required ? " *" : ""}</span>
              <input value={fills[f.id] || ""} onChange={(e) => setFills({ ...fills, [f.id]: e.target.value })} data-testid={`${prefix}-blank-${f.id}`}
                className="w-full rounded-md bg-black/40 border border-white/15 px-3 py-2 text-sm text-white outline-none focus:border-amber-400" /></label>
          ))}
        </div>
      )}
    </div>
  );
}
